import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { config, configProvider } from './config/app';
import { HttpInterceptor } from './mware/interceptors/http.interceptor';

function initializeApp(httpClient: HttpClient, document: Document) {
  return () => {
    // TODO: call API to get theme and load theme
    document.body.classList.add('default');
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: configProvider, useValue: config },
    provideHttpClient(withInterceptors([HttpInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [HttpClient, DOCUMENT],
    },
    provideClientHydration(),
    provideAnimations(), // required animations providers
    provideToastr(),
  ],
};
